module.exports = __webpack_public_path__ + "static/media/stock_tracker_logo.d66bf68d.jpg";